module.exports = __webpack_public_path__ + "img/comorbid_risks.cbd5ea18.svg";